import React from "react";
import Banner from "../Components/Banner/Banner";
import CoinsTable from "../Components/CoinsTable";

const HomePage = () => {
  return (
    <div style={{ paddingTop: 75, paddingBottom: 50 }}>
      <Banner />
      <CoinsTable />
    </div>
  );
};

export default HomePage;
